import { APIS, listMembers } from '@/utils/apiEndpoints'
import { SET_MEMBER_DIECTORY, SET_RESOURCE_COLLECTIONS } from './types'

export const fetchMemberDirectory = () => async (dispatch) => {
  try {
    const { result } = await listMembers()
    dispatch({ type: SET_MEMBER_DIECTORY, payload: result.data })
  } catch (error) {
  
  }
}
export const setMemberDirectory = (data) => async (dispatch) => {
  dispatch({ type: SET_MEMBER_DIECTORY, payload: data })
}

export const fetchResources = (data) => async (dispatch) => {
  try {
    const { result } = await APIS.listResources(data)
    dispatch({ type: SET_RESOURCE_COLLECTIONS, payload: result })
  } catch (error) {
  
  }
}

export const setResourceCollections = (data) => async (dispatch) => {
  dispatch({ type: SET_RESOURCE_COLLECTIONS, payload: data })
}
